import { Box } from '@mui/material';
import React, { ReactElement } from 'react';
import type { AttendeeEngagement } from 'services/api';

const COLORS: Record<AttendeeEngagement, { bg: string; color: string }> = {
  High: { bg: '#E7FFE9', color: '#2E7D32' },
  Medium: { bg: '#E3F2FD', color: '#1976D2' },
  Low: { bg: '#FFEBEE', color: '#9B0000' },
};

export function EngagementPill ({
  engagement,
  fullWidth = false,
}: {
  engagement: AttendeeEngagement;
  fullWidth?: boolean;
}): ReactElement {
  const c = COLORS[engagement];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: fullWidth ? '100%' : 100,
        py: '4px',
        borderRadius: '9999px',
        backgroundColor: c.bg,
        color: c.color,
        fontFamily: '\'Poppins\', sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
        whiteSpace: 'nowrap',
      }}
    >
      {engagement}
    </Box>
  );
}
